import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import { apiUrl } from "../../Config/apiUrl";
import { getMe, signOut, userIsLogin } from "../commonSlice";
import { useDispatch } from "react-redux";
import useIsLogout from "../../HelperFunction/LogoutFunction";

const baseQueryToasts = (baseUrl) => {
  const baseQuery = fetchBaseQuery({
    baseUrl,
    credentials: "include",
    // prepareHeaders: (headers, { getState }) => {
    //   const token = getState()?.auth?.token;
    //   if (token) {
    //     headers.set("authorization", `Bearer ${token}`);
    //   }

    //   return headers;
    // },
  });
  return async (args, api, extraOptions) => {
    const { error, data } = await baseQuery(args, api, extraOptions);
    if (error) {
      toast.error(error?.data?.error, { position: "top-center" });

      if (error?.status === 423) {
        Cookies.remove("token");
        localStorage.clear();
        window.location.href = "/login";
        toast.error(error?.data?.error, { position: "top-center" });

        return;
      }
    }
    return { data };
  };
};

export const AppApi = createApi({
  reducerPath: "appApi",
  baseQuery: baseQueryToasts(apiUrl),
  tagTypes: ["product", "user"],
  endpoints: (builder) => ({
    //Auth
    loginUser: builder.mutation({
      query: (formData) => ({
        url: "auth/login",
        method: "POST",
        body: formData,
      }),
    }),
    logoutUser: builder.mutation({
      query: () => ({
        url: "auth/logout",
        method: "POST",
      }),
    }),

    forgotPassword: builder.mutation({
      query: (body) => ({
        url: "auth/forgot",
        method: "POST",
        body: body,
      }),
    }),
    resetPassword: builder.mutation({
      query: (formData) => ({
        url: "auth/resetPassword",
        method: "POST",
        body: formData,
      }),
    }),

    registerUser: builder.mutation({
      query: (formData) => ({
        url: "auth/signup",
        method: "POST",
        body: formData,
      }),
    }),

    getUser: builder.query({
      query: () => `auth/profile`,
      providesTags: ["user"],
    }),

    profileSetting: builder.mutation({
      query: (formData) => ({
        url: `auth/update-profile`,
        method: "PUT",
        body: formData,
      }),
      // invalidatesTags: ["user"],
    }),

    // sell item----

    sellItem: builder.mutation({
      query: (formData) => ({
        url: "product/create",
        method: "POST",
        body: formData,
      }),
      invalidatesTags: ["product"],
    }),

    getProduct: builder.query({
      query: ({
        isLogin,
        page,
        limit,
        minPrice,
        maxPrice,
        sortOrder,
        sortBy,
        categoryId,
        filters,
        search,
      }) => {
        const endpoints = isLogin ? "product/fetchProducts" : "product/fetch";
        return `${endpoints}?page=${page}&limit=${
          limit?.value
        }&minPrice=${minPrice}&maxPrice=${maxPrice}&sortOrder=${
          sortOrder?.value
        }&sortBy=${sortBy}&categoryId=${categoryId}&search=${search}&filters=${JSON.stringify(
          filters?.length === 0 ? "" : filters
        )}`;
      },
      providesTags: ["product"],
    }),

    // my-product---------
    myProduct: builder.query({
      query: ({ id, page, limit }) =>
        `product/fetch/?sellerId=${id}&page=${page}&limit=${limit}`,
    }),
    // single-product---------
    productDetail: builder.query({
      query: ({ id, isLogin }) =>
        `${
          isLogin ? "product/fetchProducts" : "product/fetch"
        }?productId=${id}`,
    }),
    // seller-product
    getSellerProduct: builder.query({
      query: ({ id, page, limit }) =>
        `product/getSellerProducts/${id}?page=${page}&limit=${limit}`,
    }),

    // category------------
    categorySubCategory: builder.query({
      query: () => `category/fetchCategories`,
    }),

    // wishlist-----
    isWishlist: builder.mutation({
      query: ({ id, action }) => ({
        url: `product/saveToggle/${id}`,
        method: "POST",
        body: { action: action },
      }),
      // invalidatesTags: ["product"],
    }),
    getMyWishlist: builder.query({
      query: ({ page, limit }) =>
        `product/fetchProducts?savedByMe=true&page=${page}&limit=${limit}`,
    }),

    // home page apis----------
    getHomeProduct: builder.query({
      query: ({ isLogin, page, limit, categoryId }) => {
        const endpoints = isLogin ? "product/fetchProducts" : "product/fetch";
        return `${endpoints}?page=${page}&limit=${limit}&categoryId=${categoryId}`;
      },
    }),

    // order summary--
    getCheckoutProduct: builder.query({
      query: ({ id }) => `product/fetchProducts?productId=${id}&offer=true`,
    }),
    // notificationsy--
    getNotifications: builder.query({
      query: () => `chat/notifications`,
    }),
    // get filters--
    getFilters: builder.query({
      query: (categoryId) =>
        `category/filters${
          categoryId !== "all" ? `?categoryId=${categoryId}` : ``
        }`,
    }),
    getReviews: builder.query({
      query: ({ id, page, limit }) =>
        `auth/reviews?userId=${id}&page=${page}&limit=${limit}`,
    }),
    getAutoSearch: builder.query({
      query: ({ search }) =>
        `product/searchAutoCompleteProducts?search=${search}`,
    }),
  }),
});
export const {
  //auth
  useLoginUserMutation,
  useForgotPasswordMutation,
  useRegisterUserMutation,
  useLogoutUserMutation,
  useResetPasswordMutation,
  useLazyGetUserQuery,
  useProfileSettingMutation,
  // sell item-
  useSellItemMutation,
  useGetProductQuery,
  // category------
  useCategorySubCategoryQuery,
  // my-product--
  useMyProductQuery,
  // single-product--
  useProductDetailQuery,
  useGetSellerProductQuery,
  // wishlist--
  useIsWishlistMutation,
  useGetMyWishlistQuery,
  // home--page----
  useGetHomeProductQuery,
  useGetCheckoutProductQuery,
  // get--filters----
  useGetFiltersQuery,
  // notification------
  useLazyGetNotificationsQuery,
  // getReviews---
  useGetReviewsQuery,
  // auto-complete---
  useLazyGetAutoSearchQuery,
} = AppApi;

// getListOfPractitioner: builder.query({
//   query: ({ category, rating, page }) =>
//     `front-end/practitioners-list?rating=${rating}&category=${category}&page=${page}`,
//   invalidatesTags: "list-of-practitioner",
// }),

//PUT
//  updateResetPassword: builder.mutation({
//   query: ({ token, formData }) => ({
//     url: `auth/resetpassword/${token}`,
//     method: "PUT",
//     body: formData,
//   }),
// }),
